import { DimensionType } from "../../types";
import { IDimensionDTO } from "../../api"
import { FavouriteItem } from "../../../favourites/types";
import { BulkExportPayload, SavedBulkExportPayload, SubscriptionItem } from "../../../subscriptions/types";

export interface IBulkExportStep extends IDimensionDTO {
  virtual?: boolean;
}

export enum BulkExportType {
  Subscription,
  Favourite
}

export interface IBulkExportStepper {
  item?: FavouriteItem | BulkExportPayload;
  bulkType?: BulkExportType,
}